import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/prematch/custom-selection',
    },
    {
      path: '/prematch',
      name: 'prematch',
      component: () => import(/* webpackChunkName: "prematch" */ './views/prematch/Prematch.vue'),
      children: [
        {
          path: 'custom-selection',
          name: 'custom-selection',
          component: () => import(/* webpackChunkName: "custom-selection" */ './views/prematch/custom-selection/CustomSelection.vue'),
        },
        {
          path: 'custom-selection/edit/:id/:selectionType/:selectionConfig/:startDate/:endDate',
          name: 'custom-selection-edit',
          component: () => import(/* webpackChunkName: "custom-selection-edit" */ './views/prematch/custom-selection/custom-selection-edit/CustomSelectionEdit.vue'),
        },
      ],
    },
  ],
});
